<template>

</template>

<script>
    import BpmnVueFinder from './BpmnVueFinder'
    import BpmnComponentFinder from './BpmnComponentFinder'
    import ModelPanel from "../../modeling/ModelPanel"

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        mixins: [BpmnVueFinder, BpmnComponentFinder, ModelPanel],
        name: 'bpmn-property-panel',
        props: {
            drawer: {
                default: function () {
                    return false;
                },
                type: Boolean
            },
            value: Object,
            definition: Object,
        },
        computed: {},
        data() {
            return {
                canvasbase: null,
                namePanel: '',
                
                navigationDrawer: this.drawer,
                _item: this.value,
                preventWatch: false,
                x: null,
                y: null,
                width: null,
                height: null,
                style: [],
                active: null,
                tracingTag: null,
            }
        },
        created: function () {
            var me = this
            me.canvasbase = me.$parent.getComponent('bpmn-modeling-canvas')
            me.namePanel = me.value.name
            
            if (me.canvasbase.isServerModeling 
                    && me.canvasbase.isQueueModeling
                    && !me.canvasbase.isClazzModeling 
                    && !me.canvasbase.isReadModeling
            ) {
                me.panelOpenQueue()
            }

        },
        mounted: function () {
            this._item = this.value;

            if (this.value.elementView) {
                this.x = this.value.elementView.x;
                this.y = this.value.elementView.y;
                this.width = this.value.elementView.width;
                this.height = this.value.elementView.height;
            }

            //맵 형식의 스타일을 어레이타입으로 변형한다.
            var view = this.value.elementView || this.value.relationView;
            var style = [];
            if (view.style) {
                var itemStyle = JSON.parse(view.style);
                if (!$.isEmptyObject(itemStyle)) {
                    for (var key in itemStyle) {
                        style.push({
                            key: key,
                            value: itemStyle[key]
                        });
                    }
                }
                this.style = style;
            }

            if (this.value.tracingTag) {
                this.tracingTag = this.value.tracingTag;
            }

            //bpmnVue 에 프로퍼티 에디팅중임을 알린다.
            //프로퍼티 에디팅 중 데피니션 변화는 히스토리에 기록된다.
            this.bpmnVue.propertyEditing = true;
            this.$emit('update:drawer', true);
        },
        beforeDestroy() {
            var me = this

            var diff = jsondiffpatch.diff(me.value, me.copyValue)
            if (diff) {
                if (!me.isReadOnly) {
                    me.canvasbase.changedByMe = true
                    me.value.name = me.copyValue.name
                }
            } else {
                if (me.namePanel != me.copyValue.name) {
                    if (!me.isReadOnly) {
                        me.canvasbase.changedByMe = true
                        me.value.name = me.copyValue.name
                    }
                }
            }

            if (me.canvasbase.isServerModeling 
                    && me.canvasbase.isQueueModeling
                    && !me.canvasbase.isClazzModeling 
                    && !me.canvasbase.isReadModeling
            ) {
                me.panelCloseQueue()
            }

        },
        watch: {
            drawer: function (val) {
                // console.log(val)
                this.navigationDrawer = val;
            },
            //프로퍼티 창이 오픈되었을 때 모델값을 새로 반영한다.
            navigationDrawer: {
                handler: function (val, oldval) {
                    console.log('val', val);
                    if (val == true) {
                        this._item = this.value;

                        if (this.value.elementView) {
                            this.x = this.value.elementView.x;
                            this.y = this.value.elementView.y;
                            this.width = this.value.elementView.width;
                            this.height = this.value.elementView.height;
                        }

                        //맵 형식의 스타일을 어레이타입으로 변형한다.
                        var view = this.value.elementView || this.value.relationView;
                        var style = [];
                        if (view.style) {
                            var itemStyle = JSON.parse(view.style);
                            if (!$.isEmptyObject(itemStyle)) {
                                for (var key in itemStyle) {
                                    style.push({
                                        key: key,
                                        value: itemStyle[key]
                                    });
                                }
                            }
                            this.style = style;
                        }

                        if (this.value.tracingTag) {
                            this.tracingTag = this.value.tracingTag;
                        }

                        //bpmnVue 에 프로퍼티 에디팅중임을 알린다.
                        //프로퍼티 에디팅 중 데피니션 변화는 히스토리에 기록된다.
                        this.bpmnVue.propertyEditing = true;
                        this.$emit('update:drawer', true);

                        // this.toggleRightSidenav();
                    } else {
                        //프로퍼티 에디팅 해제.
                        if (this.bpmnVue) {
                            this.bpmnVue.propertyEditing = false;
                        }
                        this.$emit('update:drawer', false);

                        // this.closeRightSidenav();
                    }
                }
            },
            x: function (val) {
                this._item.elementView.x = val;
                this.$emit('update:item', this._item);
            },
            y: function (val) {
                this._item.elementView.y = val;
                this.$emit('update:item', this._item);
            },
            width: function (val) {
                this._item.elementView.width = val;
                this.$emit('update:item', this._item);
            },
            height: function (val) {
                this._item.elementView.height = val;
                this.$emit('update:item', this._item);
            },
            style: {
                handler: function (newVal, oldVal) {
                    var style = {};
                    if (newVal && newVal.length) {
                        $.each(newVal, function (i, item) {
                            style[item.key] = item.value;
                        });
                    }
                    var view = this._item.elementView || this._item.relationView;
                    view.style = JSON.stringify(style);
                    this.$emit('update:item', this._item);
                },
                deep: true
            },
            //모델러에 의해 tracingTag 가 변경되었을 경우.
            tracingTag: function (value) {
                var me = this;
                //동일함.
                if (me._item.tracingTag == value) {
                    
                }
                //이미 있음.
                else if (me.bpmnVue.checkExistTracingTag(value)) {
                    console.log('TracingTag aleardy exist.');
                }
                //트레이싱 태그 값이 바뀜.
                else if (value && value.length > 0) {
                    var oldTracingTag = me._item.tracingTag;

                    //해당 액티비티 업데이트.
                    me._item.tracingTag = value;
                    me.$emit('update:item', me._item);

                    //해당 트레이싱 태그를 사용중인 릴레이션의 source,target 을 변경한다.
                    var sequenceFlows = me.bpmnVue.data.definition.sequenceFlows;
                    if (sequenceFlows && sequenceFlows.length) {
                        $.each(sequenceFlows, function (i, relation) {
                            if (relation.sourceRef == oldTracingTag) {
                                relation.sourceRef = value;
                            }
                            if (relation.targetRef == oldTracingTag) {
                                relation.targetRef = value;
                            }
                        });
                    }
                }
            },
            "namePanel": _.debounce(function (newVal) {
                var me = this
                me.copyValue.name = newVal.toString().replace(/\n/g, "").replace(/ /gi, "")

                if (me.value.elementView) {
                    me.canvasbase.$refs[`${me.value.elementView.id}`][0].namePanel = me.copyValue.name
                } else if (me.value.relationView) {
                    me.canvasbase.$refs[`${me.value.relationView.id}`][0].namePanel = me.copyValue.name
                }
            }, 500),
        },
        methods: {
            open(ref) {
                this.navigationDrawer = true;
                console.log('Opened: ' + ref);
            },
            closePanel() {
                this.navigationDrawer = false;
                this.$emit('update:item', this._item);
                this.$emit('close');
                console.log('Closed');
            },
            // close(ref) {
            //     this.navigationDrawer = false;
            //     console.log('Closed: ' + ref);
            // },
            // closeRightSidenav() {
            //     this.$refs.rightSidenav.close();
            // },
            // toggleRightSidenav() {
            //     this.$refs.rightSidenav.toggle();
            // },
            backToHere(){
                // alert(this.value._instanceInfo.instanceId);

                var serviceLocator = this.$root.$children[0].$refs["backend"]; //TODO hardcoded
                var me = this;

                serviceLocator.invoke({
                    path: 'instance/' + me.item._instanceInfo.instanceId + "/activity/" + me.item._instanceInfo.tracingTag + "/backToHere",
                    method: 'POST',
                    data: {
                    },
                    success: function (value) {
                    window.location.reload();
                    },
                    fail: function (value) {
                    me.$root.$children[0].error('Fail to rollback due to ' + value);
                    }
                });
            },
            uuid: function () {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }

              return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">
    .md-sidenav.md-right .md-sidenav-content {
        width: 600px;
    }

</style>

